import { datadogRum } from '@datadog/browser-rum';

import type { ConfigOptions } from 'src/types';

export const bootstrap = (config: ConfigOptions) => {
  datadogRum.init({
    applicationId: '77fc1642-2db8-4b6c-b4e3-43017876bd78',
    clientToken: 'pub28a0d77d4413deafb41fe7b2871b060a',
    site: 'datadoghq.com',
    service: 'jobs-list-ui',
    env: config.environment,
    version: config.version,
    allowedTracingUrls: [
      /https:\/\/talent\.seek\.com\.au(?!\/graphql).*/,
      /https:\/\/talent\.seek\.co\.nz(?!\/graphql).*/,
      /https:\/\/talent\.staging\.seek\.com\.au(?!\/graphql).*/,
      /https:\/\/talent\.staging\.seek\.co\.nz(?!\/graphql).*/,
      // Asia Domains
      /https:\/\/ph\.employer\.seek\.com(?!\/graphql).*/,
      /https:\/\/ph\.employer\.staging\.seek\.com(?!\/graphql).*/,
      /https:\/\/th\.employer\.seek\.com(?!\/graphql).*/,
      /https:\/\/th\.employer\.staging\.seek\.com(?!\/graphql).*/,
      /https:\/\/my\.employer\.seek\.com(?!\/graphql).*/,
      /https:\/\/my\.employer\.staging\.seek\.com(?!\/graphql).*/,
      /https:\/\/hk\.employer\.seek\.com(?!\/graphql).*/,
      /https:\/\/hk\.employer\.staging\.seek\.com(?!\/graphql).*/,
      /https:\/\/id\.employer\.seek\.com(?!\/graphql).*/,
      /https:\/\/id\.employer\.staging\.seek\.com(?!\/graphql).*/,
      /https:\/\/sg\.employer\.seek\.com(?!\/graphql).*/,
      /https:\/\/sg\.employer\.staging\.seek\.com(?!\/graphql).*/,
      /http:\/\/hirer-graphql-api-.*\.hirer\.dev\.outfra\.xyz/,
    ],
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
};
